export default __webpack_public_path__ + "static/media/elemento06_web.3e4c0dbf.png";